module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('center', [(_vm.landowner && _vm.landowner.name) ? _c('h4', [_vm._v("Landowner: "), _c('span', {
    staticClass: "text-primary"
  }, [_vm._v(_vm._s(_vm.landowner.name))]), _vm._v(" ")]) : _vm._e(), _c('br'), _vm._v(" "), (_vm.siteData && _vm.siteData.siteName) ? _c('h5', [_c('i', [_c('span', {
    staticClass: "text-warning"
  }, [_vm._v(_vm._s(_vm.siteData.siteName))]), _vm._v(" (" + _vm._s(_vm.siteData.siteId) + ") "), _c('b', [_vm._v("Handover: " + _vm._s(_vm.formatDate(_vm.siteData.handover)))])])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form', {
    ref: "tenancyFrom",
    attrs: {
      "model": _vm.tenancy,
      "rules": _vm.rules,
      "inline": "",
      "label-position": "left",
      "label-width": "110px"
    },
    model: {
      value: (_vm.tenancy),
      callback: function($$v) {
        _vm.tenancy = $$v
      },
      expression: "tenancy"
    }
  }, [_c('el-tabs', {
    model: {
      value: (_vm.agMenu),
      callback: function($$v) {
        _vm.agMenu = $$v
      },
      expression: "agMenu"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Details",
      "name": "ag_details"
    }
  }, [(!_vm.landowner.id || !_vm.landedit) ? _c('el-row', {
    attrs: {
      "gutter": 6
    }
  }, [_c('el-col', {
    attrs: {
      "md": 24,
      "lg": 8
    }
  }, [_c('select-landlord', {
    attrs: {
      "label": "Landlord",
      "placeholder": "Select Existing Landlord",
      "full-object": "",
      "disabled": _vm.landowner.id > 0
    },
    on: {
      "change": _vm.updated
    },
    model: {
      value: (_vm.landowner),
      callback: function($$v) {
        _vm.landowner = $$v
      },
      expression: "landowner"
    }
  }), _vm._v(" "), _c('br')], 1), _vm._v(" "), (_vm.landowner.id) ? _c('el-col', {
    attrs: {
      "md": 24,
      "lg": 16
    }
  }, [(!_vm.addContact) ? _c('div', [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, [(_vm.landowner.contactsCount > 0) ? _c('select-contact', {
    ref: "contactSel",
    attrs: {
      "placeholder": "Select Owner's Rep.",
      "org-id": _vm.landowner.id
    },
    on: {
      "change": _vm.contactChange
    },
    model: {
      value: (_vm.tenancy.contact_id),
      callback: function($$v) {
        _vm.$set(_vm.tenancy, "contact_id", $$v)
      },
      expression: "tenancy.contact_id"
    }
  }) : _vm._e()], 1)], 1) : _c('div', {
    attrs: {
      "gutter": 6
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('text-input', {
    attrs: {
      "label": "Site Rep.",
      "prop": "name",
      "placeholder": "Full name",
      "is-prefix-icon": "",
      "prefix": "fa fa-user"
    },
    on: {
      "change": function($event) {
        _vm.contactChanged = true
      }
    },
    model: {
      value: (_vm.contact.name),
      callback: function($$v) {
        _vm.$set(_vm.contact, "name", $$v)
      },
      expression: "contact.name"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('text-input', {
    attrs: {
      "label": "Phone",
      "type": "phone",
      "prop": "phone",
      "placeholder": "Mobile phone",
      "is-prefix-icon": "",
      "prefix": "fa fa-mobile-alt"
    },
    on: {
      "change": function($event) {
        _vm.contactChanged = true
      }
    },
    model: {
      value: (_vm.contact.phone),
      callback: function($$v) {
        _vm.$set(_vm.contact, "phone", $$v)
      },
      expression: "contact.phone"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('text-input', {
    attrs: {
      "label": "e-Mail",
      "type": "email",
      "prop": "email",
      "placeholder": "e-Mail",
      "is-prefix-icon": "",
      "prefix": "fa fa-envelope"
    },
    on: {
      "change": function($event) {
        _vm.contactChanged = true
      }
    },
    model: {
      value: (_vm.contact.email),
      callback: function($$v) {
        _vm.$set(_vm.contact, "email", $$v)
      },
      expression: "contact.email"
    }
  })], 1)], 1), _vm._v(" "), (_vm.landowner.id) ? _c('el-col', {
    attrs: {
      "span": _vm.addContact ? 2 : 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": !_vm.addContact ? '.' : ''
    }
  }, [(!_vm.addContact && _vm.landowner.contactsCount > 0) ? _c('span', {
    staticClass: "text-muted"
  }, [_vm._v(" - or - ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": !_vm.addContact ? 'primary' : 'success',
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.addContact = !_vm.addContact
      }
    }
  }, [_vm._v("\n                    " + _vm._s(!_vm.addContact ? 'Add Contact' : 'Save') + "\n                  ")]), _vm._v(" "), (_vm.addContact) ? _c('el-button', {
    attrs: {
      "type": "info",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.addContact = false
      }
    }
  }, [_vm._v("\n                    Cancel\n                  ")]) : _vm._e()], 1)], 1) : _vm._e()], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 6
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "hover"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Tenancy Details:")])]), _vm._v(" "), _c('text-input', {
    attrs: {
      "label": "Land Title Ref:",
      "prop": "landTitleRef",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.tenancy.landTitleRef),
      callback: function($$v) {
        _vm.$set(_vm.tenancy, "landTitleRef", $$v)
      },
      expression: "tenancy.landTitleRef"
    }
  }), _vm._v(" "), _c('select-land-status', {
    attrs: {
      "prop": "landStatus",
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.check
    },
    model: {
      value: (_vm.tenancy.landStatus),
      callback: function($$v) {
        _vm.$set(_vm.tenancy, "landStatus", $$v)
      },
      expression: "tenancy.landStatus"
    }
  }), _vm._v(" "), _c('select-land-type', {
    attrs: {
      "placeholder": "Land Type",
      "prop": "landType",
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.check
    },
    model: {
      value: (_vm.tenancy.landType),
      callback: function($$v) {
        _vm.$set(_vm.tenancy, "landType", $$v)
      },
      expression: "tenancy.landType"
    }
  }), _vm._v(" "), _c('select-classification-type', {
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.check
    },
    model: {
      value: (_vm.tenancy.classificationType),
      callback: function($$v) {
        _vm.$set(_vm.tenancy, "classificationType", $$v)
      },
      expression: "tenancy.classificationType"
    }
  })], 1), _vm._v(" "), _c('br')], 1), _vm._v(" "), (!_vm.isPurchase(_vm.tenancy)) ? _c('el-col', {
    attrs: {
      "lg": _vm.adding ? 12 : 24,
      "md": 24
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "hover"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Deposit:")])]), _vm._v(" "), _c('currency-input', {
    attrs: {
      "label": "Deposit",
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.check
    },
    model: {
      value: (_vm.tenancy.deposit),
      callback: function($$v) {
        _vm.$set(_vm.tenancy, "deposit", $$v)
      },
      expression: "tenancy.deposit"
    }
  }), _vm._v(" "), _c('date-input', {
    attrs: {
      "label": "Date",
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.check
    },
    model: {
      value: (_vm.tenancy.depositDate),
      callback: function($$v) {
        _vm.$set(_vm.tenancy, "depositDate", $$v)
      },
      expression: "tenancy.depositDate"
    }
  }), _vm._v(" "), (!_vm.isPurchase(_vm.tenancy)) ? _c('integer-input', {
    attrs: {
      "label": "Deposit for",
      "suffix": "months",
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.check
    },
    model: {
      value: (_vm.tenancy.depositMonths),
      callback: function($$v) {
        _vm.$set(_vm.tenancy, "depositMonths", $$v)
      },
      expression: "tenancy.depositMonths"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.adding && _vm.isDesktop) ? _c('div', [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]) : _vm._e()], 1), _vm._v(" "), _c('br')], 1) : _vm._e(), _vm._v(" "), (((_vm.adding || !_vm.tenancy.started) || _vm.tenancy.count == 0) && !_vm.isPurchase(_vm.tenancy)) ? _c('el-col', {
    attrs: {
      "lg": 12,
      "md": 24
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "hover"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Tenancy Start & End:")])]), _vm._v(" "), _c('date-input', {
    attrs: {
      "label": "Start",
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.renewalCheck
    },
    model: {
      value: (_vm.renewal.started),
      callback: function($$v) {
        _vm.$set(_vm.renewal, "started", $$v)
      },
      expression: "renewal.started"
    }
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('number-input', {
    attrs: {
      "label": "Tenor (mths)",
      "min": 6,
      "max": 240,
      "step": 6,
      "disabled": !_vm.adding && _vm.disabled
    },
    on: {
      "change": _vm.check
    },
    model: {
      value: (_vm.renewal.months),
      callback: function($$v) {
        _vm.$set(_vm.renewal, "months", $$v)
      },
      expression: "renewal.months"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('i', [_vm._v(_vm._s(_vm.years) + " " + _vm._s(_vm.plural('yr', _vm.years)) + ".")])])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Expiry"
    }
  }, [_c('center', [_c('b', [_vm._v(_vm._s(_vm.formatDate(_vm.expiryDate)))])])], 1)], 1), _vm._v(" "), _c('br')], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "hover"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Financials:")])]), _vm._v(" "), _c('currency-input', {
    attrs: {
      "label": 'Land ' + _vm.tenancy.landType,
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.check
    },
    model: {
      value: (_vm.tenancy.landValue),
      callback: function($$v) {
        _vm.$set(_vm.tenancy, "landValue", $$v)
      },
      expression: "tenancy.landValue"
    }
  }), _vm._v(" "), (!_vm.isPurchase(_vm.tenancy)) ? _c('select-frequency', {
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.check
    },
    model: {
      value: (_vm.tenancy.frequency),
      callback: function($$v) {
        _vm.$set(_vm.tenancy, "frequency", $$v)
      },
      expression: "tenancy.frequency"
    }
  }) : _vm._e(), _vm._v(" "), _c('switch-input', {
    attrs: {
      "label": "Taxable"
    },
    on: {
      "change": _vm.renewalCheck
    },
    model: {
      value: (_vm.tenancy.taxable),
      callback: function($$v) {
        _vm.$set(_vm.tenancy, "taxable", $$v)
      },
      expression: "tenancy.taxable"
    }
  }), _vm._v(" "), (_vm.renewal.taxable) ? _c('currency-input', {
    attrs: {
      "label": "Tax",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.renewal.tax),
      callback: function($$v) {
        _vm.$set(_vm.renewal, "tax", $$v)
      },
      expression: "renewal.tax"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isPurchase(_vm.tenancy)) ? _c('el-row', {
    staticClass: "clearfix"
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('integer-input', {
    attrs: {
      "label": "Renewal Incr.",
      "suffix": "%",
      "min": 0,
      "max": 100,
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.renewalCheck
    },
    model: {
      value: (_vm.tenancy.increment),
      callback: function($$v) {
        _vm.$set(_vm.tenancy, "increment", $$v)
      },
      expression: "tenancy.increment"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('currency-input', {
    attrs: {
      "label": "Renewal",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.renewal.amount),
      callback: function($$v) {
        _vm.$set(_vm.renewal, "amount", $$v)
      },
      expression: "renewal.amount"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('currency-input', {
    attrs: {
      "label": "Renewal Total",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.renewal.total),
      callback: function($$v) {
        _vm.$set(_vm.renewal, "total", $$v)
      },
      expression: "renewal.total"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('br')], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": (_vm.adding ? 'Add ' : 'Update ') + 'Landowner',
      "name": "tenancy_owner"
    }
  }, [_c('edit-pane', {
    ref: "landowner",
    attrs: {
      "title": "Landonwer",
      "is-edit": _vm.landedit
    },
    on: {
      "save": _vm.onSaveLandowner,
      "cancel": function($event) {
        _vm.landedit = false
      },
      "edit": function($event) {
        _vm.landedit = true
      }
    }
  }, [_c('br'), _vm._v(" "), (_vm.landedit) ? _c('el-alert', {
    attrs: {
      "type": "info",
      "show-icon": "",
      "title": "Changes here affect all sites with the same landlord.",
      "closable": false
    }
  }) : _vm._e(), _vm._v(" "), _c('el-form', {
    ref: "landownerForm",
    attrs: {
      "model": _vm.landowner,
      "label-position": "top",
      "inline": ""
    },
    model: {
      value: (_vm.landowner),
      callback: function($$v) {
        _vm.landowner = $$v
      },
      expression: "landowner"
    }
  }, [_c('text-input', {
    attrs: {
      "label": "Landowner Name",
      "prop": "name",
      "is-prefix-icon": "",
      "prefix": "fa fa-user",
      "placeholder": "Name",
      "disabled": !_vm.landedit
    },
    on: {
      "change": function($event) {
        _vm.landownerChanged = true
      }
    },
    model: {
      value: (_vm.landowner.name),
      callback: function($$v) {
        _vm.$set(_vm.landowner, "name", $$v)
      },
      expression: "landowner.name"
    }
  }), _vm._v(" "), _c('text-input', {
    attrs: {
      "label": "Address",
      "prop": "address",
      "type": "textarea",
      "is-prefix-icon": "",
      "prefix": "fa fa-home",
      "placeholder": "Address",
      "rows": 4,
      "disabled": !_vm.landedit
    },
    on: {
      "change": function($event) {
        _vm.landownerChanged = true
      }
    },
    model: {
      value: (_vm.landowner.address),
      callback: function($$v) {
        _vm.$set(_vm.landowner, "address", $$v)
      },
      expression: "landowner.address"
    }
  }), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 16
    }
  }, [(_vm.landowner.postCode || _vm.landedit) ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('text-input', {
    attrs: {
      "label": "Post Code",
      "prop": "postCode",
      "is-prefix-icon": "",
      "prefix": "fa fa-barcode",
      "placeholder": "Post Code",
      "disabled": !_vm.landedit
    },
    on: {
      "change": function($event) {
        _vm.landownerChanged = true
      }
    },
    model: {
      value: (_vm.landowner.postCode),
      callback: function($$v) {
        _vm.$set(_vm.landowner, "postCode", $$v)
      },
      expression: "landowner.postCode"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.landowner.phone || _vm.landedit) ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('text-input', {
    attrs: {
      "label": "Phone",
      "prop": "phone",
      "is-prefix-icon": "",
      "prefix": "fa fa-phone",
      "placeholder": "Phone",
      "disabled": !_vm.landedit
    },
    on: {
      "change": function($event) {
        _vm.landownerChanged = true
      }
    },
    model: {
      value: (_vm.landowner.phone),
      callback: function($$v) {
        _vm.$set(_vm.landowner, "phone", $$v)
      },
      expression: "landowner.phone"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.landowner.email || _vm.landedit) ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('text-input', {
    attrs: {
      "label": "e-Mail",
      "prop": "email",
      "is-prefix-icon": "",
      "prefix": "fa fa-envelope",
      "placeholder": "e-mail",
      "disabled": !_vm.landedit
    },
    on: {
      "change": function($event) {
        _vm.landownerChanged = true
      }
    },
    model: {
      value: (_vm.landowner.email),
      callback: function($$v) {
        _vm.$set(_vm.landowner, "email", $$v)
      },
      expression: "landowner.email"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.landedit) ? _c('h4', [_vm._v("Owner's Site Representative")]) : _vm._e(), _vm._v(" "), _c('el-form', {
    ref: "contactForm",
    attrs: {
      "model": _vm.contact,
      "label-position": "top",
      "inline": ""
    },
    model: {
      value: (_vm.contact),
      callback: function($$v) {
        _vm.contact = $$v
      },
      expression: "contact"
    }
  }, [_c('el-row', [(_vm.landowner.contactsCount > 0) ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('select-contact', {
    ref: "contactSel",
    attrs: {
      "prop": "contact_id",
      "label": "",
      "org-id": _vm.landowner.id,
      "disabled": !_vm.landedit || _vm.addContact
    },
    on: {
      "change": _vm.contactChange
    },
    model: {
      value: (_vm.tenancy.contact_id),
      callback: function($$v) {
        _vm.$set(_vm.tenancy, "contact_id", $$v)
      },
      expression: "tenancy.contact_id"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.landowner.id) ? _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [(_vm.landowner.contactsCount > 0) ? _c('span', {
    staticClass: "text-muted"
  }, [_vm._v(" - or - ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": !_vm.addContact ? 'primary' : 'info',
      "size": "mini",
      "disabled": !_vm.landedit
    },
    on: {
      "click": function($event) {
        _vm.addContact = !_vm.addContact
      }
    }
  }, [_vm._v("\n                          " + _vm._s(!_vm.addContact ? 'Add' : 'Close') + "\n                        ")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.addContact) ? _c('el-row', {
    attrs: {
      "gutter": 12
    }
  }, [(_vm.contact.name || _vm.landedit) ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('text-input', {
    attrs: {
      "label": "Site Rep.",
      "is-prefix-icon": "",
      "prefix": "fa fa-user",
      "disabled": !_vm.landedit
    },
    on: {
      "change": function($event) {
        _vm.contactChanged = true
      }
    },
    model: {
      value: (_vm.contact.name),
      callback: function($$v) {
        _vm.$set(_vm.contact, "name", $$v)
      },
      expression: "contact.name"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.contact.phone || _vm.landedit) ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('text-input', {
    attrs: {
      "label": "Phone",
      "type": "phone",
      "prop": "phone",
      "is-prefix-icon": "",
      "prefix": "fa fa-mobile-alt",
      "disabled": !_vm.landedit
    },
    on: {
      "change": function($event) {
        _vm.contactChanged = true
      }
    },
    model: {
      value: (_vm.contact.phone),
      callback: function($$v) {
        _vm.$set(_vm.contact, "phone", $$v)
      },
      expression: "contact.phone"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.contact.email || _vm.landedit) ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('text-input', {
    attrs: {
      "label": "e-Mail",
      "type": "email",
      "prop": "email",
      "is-prefix-icon": "",
      "prefix": "fa fa-envelope",
      "disabled": !_vm.landedit
    },
    on: {
      "change": function($event) {
        _vm.contactChanged = true
      }
    },
    model: {
      value: (_vm.contact.email),
      callback: function($$v) {
        _vm.$set(_vm.contact, "email", $$v)
      },
      expression: "contact.email"
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.isManager('finance')) ? _c('h4', [_vm._v("Bank Details")]) : _vm._e(), _vm._v(" "), (_vm.isManager('finance')) ? _c('el-collapse', {
    attrs: {
      "accordion": ""
    },
    model: {
      value: (_vm.bene),
      callback: function($$v) {
        _vm.bene = $$v
      },
      expression: "bene"
    }
  }, _vm._l((_vm.beneList), function(n) {
    return _c('el-collapse-item', {
      key: n,
      attrs: {
        "name": 'beneficiary' + n,
        "title": 'Beneficiary ' + n
      }
    }, [_c('el-row', {
      attrs: {
        "gutter": 16
      }
    }, [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('text-input', {
      attrs: {
        "label": "Beneficiary Name",
        "disabled": !_vm.landedit && !_vm.disabled
      },
      on: {
        "change": function($event) {
          _vm.landownerChanged = true
        }
      },
      model: {
        value: (_vm.landowner['beneficiaryName' + n]),
        callback: function($$v) {
          _vm.$set(_vm.landowner, 'beneficiaryName' + n, $$v)
        },
        expression: "landowner['beneficiaryName' + n]"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('text-input', {
      attrs: {
        "label": "Registration No.",
        "disabled": !_vm.landedit && !_vm.disabled
      },
      on: {
        "change": function($event) {
          _vm.landownerChanged = true
        }
      },
      model: {
        value: (_vm.landowner['registrationNo' + n]),
        callback: function($$v) {
          _vm.$set(_vm.landowner, 'registrationNo' + n, $$v)
        },
        expression: "landowner['registrationNo' + n]"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('text-input', {
      attrs: {
        "label": "Bank Name",
        "disabled": !_vm.landedit && !_vm.disabled
      },
      on: {
        "change": function($event) {
          _vm.landownerChanged = true
        }
      },
      model: {
        value: (_vm.landowner['bankName' + n]),
        callback: function($$v) {
          _vm.$set(_vm.landowner, 'bankName' + n, $$v)
        },
        expression: "landowner['bankName' + n]"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('text-input', {
      attrs: {
        "label": "Bank Account",
        "disabled": !_vm.landedit && !_vm.disabled
      },
      on: {
        "change": function($event) {
          _vm.landownerChanged = true
        }
      },
      model: {
        value: (_vm.landowner['bankAccount' + n]),
        callback: function($$v) {
          _vm.$set(_vm.landowner, 'bankAccount' + n, $$v)
        },
        expression: "landowner['bankAccount' + n]"
      }
    })], 1)], 1)], 1)
  }), 1) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.canAccess('property|finance|admin')) ? _c('el-tab-pane', {
    attrs: {
      "label": "Utility Details",
      "name": "utility_details"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('select-utility', {
    attrs: {
      "label": "Provider"
    },
    model: {
      value: (_vm.tenancy.util_id),
      callback: function($$v) {
        _vm.$set(_vm.tenancy, "util_id", $$v)
      },
      expression: "tenancy.util_id"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('integer-input', {
    attrs: {
      "label": "Acc. #"
    },
    model: {
      value: (_vm.tenancy.utilAccount),
      callback: function($$v) {
        _vm.$set(_vm.tenancy, "utilAccount", $$v)
      },
      expression: "tenancy.utilAccount"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('currency-input', {
    attrs: {
      "label": "Deposit"
    },
    model: {
      value: (_vm.tenancy.utilDeposit),
      callback: function($$v) {
        _vm.$set(_vm.tenancy, "utilDeposit", $$v)
      },
      expression: "tenancy.utilDeposit"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('date-input', {
    attrs: {
      "label": "Deposit Date"
    },
    on: {
      "change": _vm.updated
    },
    model: {
      value: (_vm.tenancy.utilDepositDate),
      callback: function($$v) {
        _vm.$set(_vm.tenancy, "utilDepositDate", $$v)
      },
      expression: "tenancy.utilDepositDate"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('text-input', {
    attrs: {
      "label": "Utility Address",
      "type": "textarea",
      "rows": 3
    },
    model: {
      value: (_vm.tenancy.utilAddress),
      callback: function($$v) {
        _vm.$set(_vm.tenancy, "utilAddress", $$v)
      },
      expression: "tenancy.utilAddress"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.canAccess('property|project|maintenance|admin')) ? _c('el-tab-pane', {
    attrs: {
      "label": "Site Details",
      "name": "site_details"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('integer-input', {
    attrs: {
      "label": "Plot Width",
      "suffix": "m."
    },
    model: {
      value: (_vm.tenancy.width),
      callback: function($$v) {
        _vm.$set(_vm.tenancy, "width", $$v)
      },
      expression: "tenancy.width"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8,
      "offset": 1
    }
  }, [_c('integer-input', {
    attrs: {
      "label": "Plot Depth",
      "suffix": "m."
    },
    model: {
      value: (_vm.tenancy.depth),
      callback: function($$v) {
        _vm.$set(_vm.tenancy, "depth", $$v)
      },
      expression: "tenancy.depth"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Remarks",
      "name": "ag_remarks"
    }
  }, [_c('html-input', {
    model: {
      value: (_vm.tenancy.remarks),
      callback: function($$v) {
        _vm.$set(_vm.tenancy, "remarks", $$v)
      },
      expression: "tenancy.remarks"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-799f419c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/property/UpdateTenancy.vue
// module id = 1572
// module chunks = 0